import { matchPath } from 'react-router';

import { ROUTES } from '#constants/routes';

export const getCurrentRoute = (pathname = location.pathname) =>
  Object.values(ROUTES).find(aRoute => matchPath(pathname, aRoute));

export const currentRouteExists = pathname => !!getCurrentRoute(pathname);
